import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const row = css`
  padding: 20px 0;
  border-bottom: 1px solid ${colors.gray.light};
  display: flex;
  justify-content: space-between;

  &:last-of-type {
    margin-bottom: 20px;
  }
`;

export const icon = css`
  color: ${colors.gray.light};
  height: 42px;
  transform: rotate(90deg);
  margin-right: 20px;
`;
